import React, { useState } from 'react'
import { Header, Label, List, Icon, Item, Grid } from 'semantic-ui-react'
import { useTranslation } from "react-i18next";

import "./AccommodationRules.css"
import { Smoking } from '../../../../assets/icons/Icons';

const AccommodationRules = () => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false)
    return (<>
        <Header as='h3'>{t("property:MoreInformation")}</Header>
        <Grid columns={2} className="m-1-t" stackable>
            <Grid.Column>
                <Header as='h4'>{t("property:Rules")}</Header>
                <Label basic className="border-none d-flex flex-row align-items-center ">
                    <Icon className="p-05-r p-05-l m-0 m-4px-b" size="large" name='clock' color="" />
                    <Header className="m-0" as='h5'> {t("property:CheckinTime")} : {t("property:From")} 14:00 {t("property:To")} 00:00</Header>
                </Label>
                <Label basic className="border-none d-flex flex-row align-items-center ">
                    <Icon className="p-05-r p-05-l m-0 m-4px-b" size="large" name='clock outline' color="" />
                    <Header className="m-0" as='h5'> {t("property:CheckoutTime")} : 12:00</Header>
                </Label>

                <Label basic className="border-none d-flex flex-row align-items-center ">
                    <i className="not-icon"><Icon className="p-05-r p-05-l m-0 m-4px-b" size="large" name='paw' color="" /></i>
                    <Header className="m-0" as='h5'> {t("property:Pets")} {t("property:NotAllowed")}</Header>
                </Label>
                <Label basic className="border-none d-flex flex-row align-items-center ">
                    <Icon className="p-05-r p-05-l m-0 m-4px-b" size="large" name='group' color="" />
                    <Header className="m-0" as='h5'> {t("property:Party")} {t("property:AreAllowed")}</Header>
                </Label>
                <Label basic className="border-none d-flex flex-row align-items-center ">
                    <i className="not-icon"><Smoking /></i>
                    <Header className="m-0" as='h5'> {t("property:Smoking")} {t("property:NotAllowed")}</Header>
                </Label>

            </Grid.Column>
            {/* <Grid.Column>
                <Header as='h4'>{t("property:Health&Safety")}</Header>

            </Grid.Column> */}
            <Grid.Column>
                <Header as='h4'>{t("property:CancellationPolicy")}</Header>

                <List bulleted>
                    <List.Item>کسر کل مبلغ پرداختی به عنوان خسارت: در صورت کنسل کردن رزرو مبلغی بازگشت داده نمی‌شود</List.Item>
                    <List.Item>رزروهای بلند مدت (۱۴ روز به بالا): کسر مبلغ 7 شب اول + 20% از مابقی مبلغ رزرو به عنوان خسارت محاسبه می‌شود</List.Item>

                </List>
            
               

            </Grid.Column>
        </Grid>
    </>
    )
}
export default AccommodationRules